import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { MDBTableHead, MDBTable, MDBTableBody } from "mdbreact";
import { Tag, Dropdown } from "antd";
import { ItemType } from "antd/es/menu/interface";
import moment from "moment";
import { Loader } from "../../../../UI/Loaders/Loaders";
import { appInsights } from "../../../../config/appInsights";
import Paginator from "../../../Pagination/Pagination.component";
import CustomSelectDropdown from "../../../CustomHTMLElements/CustomSelectDropdown";
import {
  usePendingWalletCreationRequests,
  IPendingWalletCreationRequest,
} from "../hooks/usePendingWalletCreationRequests";
import ViewWalletDetailsModal from "./ViewWalletDetailsModal";
import ApproveWalletModal from "./Modals/ApproveWalletModal";
import { ReactComponent as Ellipses } from "../../../../assets/svg/icons/dots-v.svg";

import styles from "./pendingWalletCreationRequests.module.scss";

const PendingWalletCreationRequests = () => {
  const [query, setQuery] = useState({
    page: 1,
    pageSize: 10,
    searchValue: "",
    startDate: "",
    endDate: "",
  });
  const [state, setState] = useState({
    page: 1,
    pageSize: 10,
    searchValue: "",
    startDate: "",
    endDate: "",
  });
  const [selectedWallet, setSelectedWallet] =
    useState<IPendingWalletCreationRequest | null>(null);
  const [isApproveModalVisible, setIsApproveModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const history = useHistory();

  useEffect(() => {
    appInsights.trackPageView({
      name: "PendingWalletCreationRequests.tsx",
      isLoggedIn: true,
    });
  }, []);

  const {
    data: allPendingRequests,
    status,
    error,
  } = usePendingWalletCreationRequests({
    startDate: query.startDate,
    endDate: query.endDate,
    searchValue: query.searchValue,
  });

  // Frontend pagination
  const startIndex = (query.page - 1) * query.pageSize;
  const endIndex = startIndex + query.pageSize;
  const paginatedData = allPendingRequests?.data?.slice(startIndex, endIndex);
  const totalCount = allPendingRequests?.data?.length || 0;

  const pendingRequests = allPendingRequests
    ? {
        ...allPendingRequests,
        data: paginatedData || [],
      }
    : undefined;

  let RenderedComponent = null;
  if (!pendingRequests && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Pending Wallet
            Creation Requests
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader
        centered={true}
        text="Loading Pending Wallet Creation Requests..."
      />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              Pending Wallet Creation Requests, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (pendingRequests &&
        pendingRequests.data &&
        pendingRequests.data.length === 0) ||
      (pendingRequests && !pendingRequests.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no Pending
              Wallet Creation Requests
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <>
          <MDBTable
            responsive
            minimal="true"
            striped={false}
            bordered
            hover
            id="table-to-xls"
          >
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>Target ID</th>
                <th>Consumer Type</th>
                <th>Client Type</th>
                <th>Currency</th>
                <th>Provider Type</th>
                <th>Effective Date</th>
                <th>Digital Bank</th>
                <th>Created By Admin</th>
                <th>Post No Debit</th>
                <th>Note</th>
                <th>Action</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {pendingRequests &&
                pendingRequests.data.map((data, _id: number) => {
                  const {
                    targetId,
                    consumerType,
                    clientType,
                    currency,
                    providerType,
                    effectiveDate,
                    isDigitalBank,
                    createdByAdmin,
                    postNoDebit,
                    note,
                  } = data;
                  return (
                    <tr key={_id}>
                      <td>{(query.page - 1) * query.pageSize + (_id + 1)}</td>
                      <td>{targetId}</td>
                      <td>{consumerType}</td>
                      <td>{clientType}</td>
                      <td>{currency}</td>
                      <td>{providerType}</td>
                      <td>
                        {effectiveDate
                          ? moment(effectiveDate).format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td>
                        <Tag
                          color={isDigitalBank ? "success" : "default"}
                          className={styles.statusBadge}
                        >
                          {isDigitalBank ? "Yes" : "No"}
                        </Tag>
                      </td>
                      <td>
                        <Tag
                          color={createdByAdmin ? "processing" : "default"}
                          className={styles.statusBadge}
                        >
                          {createdByAdmin ? "Yes" : "No"}
                        </Tag>
                      </td>
                      <td>
                        <Tag
                          color={postNoDebit ? "warning" : "default"}
                          className={styles.statusBadge}
                        >
                          {postNoDebit ? "Yes" : "No"}
                        </Tag>
                      </td>
                      <td>{note}</td>
                      <td>
                        <Dropdown
                          menu={{
                            items: [
                              {
                                key: "view",
                                label: (
                                  <a onClick={() => handleViewDetails(data)}>
                                    View Details
                                  </a>
                                ),
                              },
                              {
                                key: "approve",
                                label: (
                                  <a onClick={() => handleApprove(data)}>
                                    Approve
                                  </a>
                                ),
                              },
                              {
                                key: "deny",
                                label: (
                                  <a onClick={() => handleDeny(data)}>Deny</a>
                                ),
                              },
                            ] as ItemType[],
                          }}
                          trigger={["click"]}
                        >
                          <span
                            className="cursor-pointer"
                            onClick={(e) => e.preventDefault()}
                          >
                            <Ellipses />
                          </span>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
        </>
      );
    }
  }

  const handleFilterChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setState((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  const filterData = () => {
    setQuery(state);
  };

  const handleClear = () => {
    setState({
      page: 1,
      pageSize: 10,
      searchValue: "",
      startDate: "",
      endDate: "",
    });
    setQuery({
      page: 1,
      pageSize: 10,
      searchValue: "",
      startDate: "",
      endDate: "",
    });
  };

  const handlePageSizeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newPageSize = parseInt(event.target.value);
    setState((prevParams) => ({
      ...prevParams,
      pageSize: newPageSize,
      page: 1,
    }));
    setQuery((prevParams) => ({
      ...prevParams,
      pageSize: newPageSize,
      page: 1,
    }));
  };

  const handleViewDetails = (walletData: IPendingWalletCreationRequest) => {
    setSelectedWallet(walletData);
    setIsModalVisible(true);
  };

  const handleApprove = (walletData: IPendingWalletCreationRequest) => {
    setSelectedWallet(walletData);
    setIsApproveModalVisible(true);
  };

  const handleDeny = (walletData: IPendingWalletCreationRequest) => {
    console.log("Deny:", walletData);
    // TODO: Implement deny logic
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedWallet(null);
  };

  const handleCloseApproveModal = () => {
    setIsApproveModalVisible(false);
    setSelectedWallet(null);
  };

  const handleApprovalSuccess = () => {
    // Refetch data after successful approval
    window.location.reload();
  };

  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x animated fadeInRight">
        <h3 className="page-title mb-4">Pending Wallet Creation Requests</h3>

        <div className="row">
          <div className="form-group col-md-2">
            <label>From</label>
            <div className="input-group">
              <input
                type="date"
                name="startDate"
                className="form-control"
                value={state.startDate}
                onChange={handleFilterChange}
              />
            </div>
          </div>
          <div className="form-group col-md-2">
            <label>To</label>
            <div className="input-group">
              <input
                type="date"
                className="form-control"
                name="endDate"
                value={state.endDate}
                onChange={handleFilterChange}
              />
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <CustomSelectDropdown
                name="pageSize"
                onChange={handlePageSizeChange}
                isShowDropdownArrow
                value={state.pageSize}
              >
                <option value={10}>10 Entries</option>
                <option value={20}>20 Entries</option>
                <option value={50}>50 Entries</option>
                <option value={100}>100 Entries</option>
              </CustomSelectDropdown>
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <button
                className="btn advancly-btn ml-2 form-control"
                onClick={filterData}
              >
                Search
              </button>
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <button
                type="submit"
                className={`btn advancly-red-btn btn-md ml-3`}
                style={{ height: "3rem" }}
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        <div>{RenderedComponent}</div>

        <Paginator
          size={query.pageSize}
          page={query.page}
          count={totalCount}
          changeCurrentPage={(pageNumber: number) =>
            setQuery({ ...state, page: pageNumber })
          }
        />
      </div>

      <ViewWalletDetailsModal
        visible={isModalVisible}
        onClose={handleCloseModal}
        walletData={selectedWallet}
      />

      <ApproveWalletModal
        visible={isApproveModalVisible}
        onClose={handleCloseApproveModal}
        walletData={selectedWallet}
        onSuccess={handleApprovalSuccess}
      />
    </div>
  );
};

export default PendingWalletCreationRequests;
